import { Pipe, PipeTransform } from '@angular/core';

// Interfaces
import { Municipio } from '@shared/interfaces';

@Pipe({ name: 'municipioDescripcion' })
export class MunicipioDescripcionPipe implements PipeTransform {
  transform(id: string | null, municipios: Municipio[]): string {
    if (!id || !municipios) return '';
    const municipio = municipios.find((m) => m.id === id);
    return municipio?.nombre || id;
  }
}
